import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'

// CSS Files
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

// Elements
import Image from 'components/shared/Image'

const SliderWrapper = styled.div`
  & .slick-slide {
    height: 70%;
  }
`

const CustomImage = styled(Image)`
  width: 180px;
  height: 180px;
  object-fit: cover;
  border-radius: 50%;

  @media (max-width: 575px) {
    width: 120px;
    height: 120px;
  }

  @media (min-width: 481px) and (max-width: 991px) {
    /* width: 100%; */
  }
`

function Team() {
  const { team } = useStaticQuery(graphql`
    {
      team: allWordpressWpOnzeMensen(sort: { order: ASC, fields: date }) {
        edges {
          node {
            acf {
              image {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 231) {
                      ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                  }
                }
              }
              name
              function
            }
          }
        }
      }
    }
  `)

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <SliderWrapper style={{ overflowX: 'hidden' }}>
      <Slider {...settings}>
        {team.edges.map(({ node: { acf } }, index) => (
          <div
            className="d-flex flex-wrap flex-column align-items-center justify-content-center"
            key={index}
          >
            <CustomImage src={acf.image} />
            <div className="text-center">
              <p className="text-center mt-3 mb-0 font-size-m font-weight-bold text-uppercase">
                {acf.function}
              </p>
              <p className="text-center font-size-m">{acf.name}</p>
            </div>
          </div>
        ))}
      </Slider>
    </SliderWrapper>
  )
}

export default Team
